import React from "react";
import { navigate } from "../../../lib/router";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";
import { Shield, ChevronRight } from "lucide-react";
import { SectionCard } from "../../../components/SectionCard";
import { Button } from "../../../components/ui/button";

export function InsuranceProvidersSection() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].insuranceProviders;

  return (
    <SectionCard
      header={
        <div className="flex items-center gap-2">
          <Shield className="h-3.5 w-3.5 text-neutral-400" />
          {t.header}
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-neutral-500">
          {t.description}
        </p>
        <Button 
          className="w-full justify-between" 
          variant="outline"
          onClick={() => navigate("/app/settings/insurance-providers")}
        >
          {t.manage}
          <ChevronRight className="h-4 w-4 ml-2 text-neutral-400" />
        </Button>
      </div>
    </SectionCard>
  );
}